export default __webpack_public_path__ + "static/media/banner-02.abf5552b.jpg";